<template>
  <BigScreen @click="111"></BigScreen>
  <div id="canvasContainer" class="home" ref="screenDom">
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import ThreePlus from "../three/index";
import BigScreen from "../components/BigScreen.vue";
// let screenDom = ref(null);

onMounted(() => {
  let threePlus = new ThreePlus("#canvasContainer");
  window.threePlus = threePlus;
  threePlus.camera.position.set(0, 280, 540);
  threePlus.setBgArr(['1.jpg', '2.jpg', '3.jpg', '4.jpg', '5.jpg', '6.jpg'])
});
</script>

<style lang="scss">
.home {
  width: 100%;
  height: 100vh;
  transform-origin: 0 0;
}

.canvas-container {
  width: 100%;
  height: 100%;
}

.button-group {
  position: absolute;
  top: 64px;
  right: 480px;
}
.title-bg {
    padding: 4px 26px;
    background-color: #0a2b30;
}
</style>
